import { TextAlign as FluentTextAlign, TextFont as FluentTextFont, TextSize as FluentTextSize, TextWeight as FluentTextWeight } from "@fluentui/web-components";
export const TextAligns = { ...FluentTextAlign };
export const TextFonts = { ...FluentTextFont };
export const TextSizes = { ...FluentTextSize };
export const TextWeights = { ...FluentTextWeight };
//# sourceMappingURL=text.options.js.map